<template>
    <div class="queue">
        <div v-if="getQueueEntries.length > 0">
            <h3>Laufender Import</h3>
            <div>
                <strong>{{ getQueueEntries.length }}</strong>
                <div class="right">
                    Elemente zu importieren
                    <span v-if="isQueueRunning">Status läuft</span>
                    <span v-else>Status wartend</span>
                </div>
            </div>
        </div>
        <div class="formItem" v-if="getErrorText">
            <v-textarea
                    class="sr-textarea"
                    hide-details
                    disabled
                    readonly
                    :value="getErrorText"
            >
            </v-textarea>
            <button class="btn-icon-only icon-trash" @click="clearQueue"></button>
        </div>
    </div>
</template>

<script>
  import _ from 'lodash'
  import QueueHelper from '@/helper/QueueHelper'

  export default {
    created () {
      this.$store.dispatch('queue/fetchEntries').then((data) => {
        if (data.length > 0) {
          QueueHelper.changeInterval(1000)
        }
      })
    },
    beforeDestroy () {
      if (this.getQueueEntries.length === 0) {
        QueueHelper.destroy()
      } else {
        QueueHelper.changeInterval()
      }
    },
    methods: {
      clearQueue () {
        this.$dialog.delete({
          title: 'Warteschlange leeren',
          message: 'Sind Sie sicher, dass sie alle Fehler in der Warteschlange entfernen wollen?'
        }).then((result) => {
          if (result.confirmed) {
            this.$store.dispatch('queue/clear').then((response) => {
              this.$alert.success('Fehler in der Warteschlange erfolgreich entfernt')
            }).catch((error) => {
              this.$alert.error('Leider lief etwas schief')
              return error
            })
          }

          return result
        }).catch((error) => {
          this.$alert.error('Leider lief etwas schief')
          return error
        })
      }
    },
    computed: {
      isQueueRunning () {
        return this.$store.getters['queue/getEntries'].filter((entry) => entry.status >= 2 && entry.status <= 3).length > 0
      },
      getQueueEntries () {
        this.$emit('hasEntries', this.$store.getters['queue/getEntries'].length > 0)

        return this.$store.getters['queue/getEntries'].filter((entry) => !entry.error)
      },
      getErrorText () {
        let entries = this.$store.getters['queue/getEntries'].filter((entry) => entry.error)

        return _.flatMap(entries, (entry) => entry.description + ' --' + entry.error).join('\r\n')
      }
    }
  }
</script>

<style scoped>

</style>
